module.exports = __webpack_public_path__ + "img/payout.53cb8d41.png";